var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-service-component"},[_c('div',{staticClass:"contact-service",on:{"click":_vm.contactService}},[_c('img',{staticClass:"icon-contact-service",attrs:{"src":require("./img/icon_contact_service.png")}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4982b009","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/projects/hsbpc/views/welcome/components/contact-service.vue
// module id = null
// module chunks = 